import createBootstrapLoader from 'actions/bootstrap/createBootstrapLoader'
import { createFetchWidgetsLoader } from './createFetchWidgets'

const BOOTSTRAP_LOADERS = [createFetchWidgetsLoader()]

export const doBootstrapWidgets = createBootstrapLoader(BOOTSTRAP_LOADERS)
